import { render } from "./NtfcView.vue?vue&type=template&id=163a6264&ts=true"
import script from "./NtfcView.vue?vue&type=script&lang=ts"
export * from "./NtfcView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__